<template>
  <div class="szw-flex szw-p-2 szw-justify-center szw-rounded-lg w-full szw-bg-section-static szw-text-text-icon-primary">
    <!-- HOME TEAM -->
    <div :class="['szw-gap-2 szw-items-center  szw-animate-pulse', isSmallWidgetContainerSize ? 'szw-col__center' : 'szw-row__center szw-flex-row-reverse']">
      <div class="szw-bg-section-static szw-h-10 szw-w-10 szw-rounded-full"></div>
      <span :class="['szw-font-semibold szw-text-base szw-text-center szw-bg-section-static szw-h-6 szw-rounded', isSmallWidgetContainerSize ? 'szw-w-12' : 'szw-w-35']"></span>
    </div>

    <!-- UPCOMING EVENT HEADER MODE -->
    <div :class="upcomingEventSectionClasses">
      <span class="szw-font-semibold szw-text-base szw-text-center szw-bg-section-static szw-w-24 szw-h-6 szw-rounded"></span>
      <div class="szw-p-1 szw-bg-section-static szw-rounded szw-text-center szw-h-8 szw-w-12"></div>
    </div>

    <!-- AWAY TEAM -->
    <div :class="['szw-gap-2 szw-items-center szw-animate-pulse', isSmallWidgetContainerSize ? 'szw-col__center' : 'szw-row__center']">
      <div class="szw-bg-section-static szw-h-10 szw-w-10 szw-rounded-full"></div>
      <span :class="['szw-font-semibold szw-text-base szw-text-center szw-bg-section-static szw-h-6 szw-rounded', isSmallWidgetContainerSize ? 'szw-w-12' : 'szw-w-35']"></span>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  isSmallWidgetContainerSize: {
    type: Boolean,
    default: false
  }
})

const upcomingEventSectionClasses = computed(() => [
  'szw-flex szw-flex-col szw-items-center szw-p-1.5 szw-text-nowrap szw-gap-2',
  props.isSmallWidgetContainerSize ? 'szw-mx-2' : 'szw-mx-4'
])
</script>
